import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import { Exam } from "src/app/models/exam";
import { Page } from "src/app/models/page";
import { PageObject } from "src/app/models/pageobject";
import { ExamService } from "src/app/services/exam.service";
import { EventsHubService, EDITORMESSAGETYPE } from "src/app/services/eventshub.service";

@Component({
  selector: "hkt-objectshierarchy",
  templateUrl: "./objectshierarchy.component.html",
  styleUrls: ["./objectshierarchy.component.scss"],
})
export class ObjectsHierarchyComponent implements OnInit, OnDestroy {
  exam: Exam;
  examSubscription: Subscription;
  eventsHubSubscription: Subscription;
  currentPage: Page;
  currentObject: PageObject;

  constructor(
    private examService: ExamService,
    private eventsHubService: EventsHubService,
  ) {}

  ngOnInit() {
    this.exam = this.examService.currentExam;
    this.currentPage = this.exam.pages[this.exam.currentPageIndex];
    this.currentObject = null;

    this.examSubscription = this.examService.onCurrentExamChange.subscribe(exam => {
      this.exam = exam;
      this.currentPage = this.exam.pages[this.exam.currentPageIndex];
      this.currentObject = null;
    });

    this.eventsHubSubscription = this.eventsHubService.onEditorMessage.subscribe(msg => {
      if (msg.type == EDITORMESSAGETYPE.SelectPage) {
        this.currentPage = msg.data;
        this.currentObject = null;
      } else if (msg.type == EDITORMESSAGETYPE.SelectObject) {
        this.currentObject = msg.data;
      }
    });
  }

  ngOnDestroy() {
    this.examSubscription.unsubscribe();
    this.eventsHubSubscription.unsubscribe();
  }
}
